(function (module) {
    'use strict';

    //CARDS WITH INFO TO SHOW/HIDE
    const features = {
        browser: {
            times: {
                show: false,
            }, settings: {
                show: true,
            }, status: {
                show: true,
            }, appPreview: {
                show: true,
            }, reporting: {
                show: false,
            }, details: {
                show: true,
            },
        }, chrome: {
            times: {
                show: false,
            }, settings: {
                show: true,
            }, status: {
                show: true,
            }, appPreview: {
                show: true,
            }, reporting: {
                show: false,
            }, details: {
                show: true,
            },
        }, samsung: {
            times: {
                show: true,
            }, settings: {
                show: true,
            }, volume: {
                show: true,
            }, brightness: {
                show: true,
            }, status: {
                show: true,
            }, appPreview: {
                show: true,
            }, reporting: {
                show: true,
            }, details: {
                show: true,
            },
        }, tizen: {
            times: {
                show: true,
            }, settings: {
                show: true,
            }, volume: {
                show: true,
            }, brightness: {
                show: true,
            }, status: {
                show: true,
            }, appPreview: {
                show: true,
            }, reporting: {
                show: true,
            }, details: {
                show: true,
            },
        }, lg: {
            times: {
                show: true,
            }, settings: {
                show: true,
            }, volume: {
                show: true,
            }, brightness: {
                show: true,
            }, status: {
                show: true,
            }, appPreview: {
                show: true,
            }, reporting: {
                show: true,
            }, details: {
                show: true,
            },
        }, brightsign: {
            times: {
                show: true,
            }, settings: {
                show: true,
            }, status: {
                show: true,
            }, appPreview: {
                show: true,
            }, reporting: {
                show: true,
            }, details: {
                show: true,
            },
        }, windows: {
            times: {
                show: false,
            }, settings: {
                show: true,
            }, status: {
                show: true,
            }, appPreview: {
                show: true,
            }, reporting: {
                show: true,
            }, details: {
                show: true,
            },
        },
    };
    const featuresDeviceSpecific = {
        lg: {
            times: {
                timer: true, timezone: true,
            },
            settings: {
                orientation: true,
                volume: true,
                brightness: true,
                reboot: true,
                reload: true,
                update: true,
                remoteControl: true,
                on: false,
                extraOrientations: false,
            },
            status: {
                preview: true, connection: true,
            },
            reporting: {
                cpu: true,
                disk: true,
                ram: true,
                temperature: true,
                networkType: true,
                networkName: true,
                ip: true,
                signal: true,
            },
            details: {
                uuid: false,
                deviceUuid: false,
                serial: true,
                manufacturer: true,
                model: true,
                resolution: true,
                created: true,
                updated: true,
                ua: true,
                type: true,
                browser: true,
                browserVs: true,
                os: true,
                osVs: true,
                firmware: true,
                rocket: true,
                extra: false,
            },
        }, samsung: {
            times: {
                timer: true, timezone: false,
            }, settings: {
                orientation: true,
                volume: true,
                brightness: true,
                reboot: true,
                reload: true,
                update: true,
                remoteControl: true,
                on: true,
            }, status: {
                preview: true, connection: true,
            }, reporting: {
                cpu: true,
                disk: true,
                ram: true,
                temperature: true,
                networkType: true,
                networkName: true,
                ip: true,
                signal: true,
            }, details: {
                uuid: true,
                deviceUuid: true,
                serial: true,
                manufacturer: true,
                model: true,
                resolution: true,
                created: true,
                updated: true,
                ua: true,
                type: true,
                browser: true,
                browserVs: true,
                os: true,
                osVs: true,
                firmware: true,
                rocket: true,
                extra: false,
            },
        }, tizen: {
            times: {
                timer: true, timezone: false,
            }, settings: {
                orientation: true,
                volume: true,
                brightness: true,
                reboot: true,
                reload: true,
                update: true,
                remoteControl: true,
                on: true,
                extraOrientations: false,
            }, status: {
                preview: true, connection: true,
            }, reporting: {
                cpu: true,
                disk: true,
                ram: true,
                temperature: true,
                networkType: true,
                networkName: true,
                ip: true,
                signal: true,
            }, details: {
                uuid: true,
                deviceUuid: true,
                serial: true,
                manufacturer: true,
                model: true,
                resolution: true,
                created: true,
                updated: true,
                ua: true,
                type: true,
                browser: true,
                browserVs: true,
                os: true,
                osVs: true,
                firmware: true,
                rocket: true,
                extra: false,
            },
        }, browser: {
            times: {
                timer: false, timezone: false,
            }, settings: {
                orientation: false, volume: false, brightness: false, reboot: false, reload: false, restart: true, // restart rocket app
                update: true, remoteControl: false, on: false,
                extraOrientations: false,
            }, status: {
                preview: false, connection: true,
            }, reporting: {
                cpu: false,
                disk: false,
                ram: false,
                temperature: false,
                networkType: false,
                networkName: false,
                ip: false,
                signal: false,
            }, details: {
                uuid: false,
                deviceUuid: false,
                serial: false,
                manufacturer: false,
                model: false,
                resolution: true,
                created: true,
                updated: true,
                ua: true,
                type: true,
                browser: true,
                browserVs: true,
                os: true,
                osVs: true,
                firmware: false,
                rocket: true,
                extra: false,
            },
        }, chrome: {
            times: {
                timer: false, timezone: false,
            }, settings: {
                orientation: false, volume: false, brightness: false, reboot: false, reload: false, restart: true, // restart rocket app
                update: true, remoteControl: false, on: false,
            }, status: {
                preview: false, connection: true,
            }, reporting: {
                cpu: false,
                disk: false,
                ram: false,
                temperature: false,
                networkType: false,
                networkName: false,
                ip: false,
                signal: false,
            }, details: {
                uuid: false,
                deviceUuid: false,
                serial: false,
                manufacturer: false,
                model: false,
                resolution: true,
                created: true,
                updated: true,
                ua: true,
                type: true,
                browser: true,
                browserVs: true,
                os: true,
                osVs: true,
                firmware: false,
                rocket: true,
                extra: false,
            },
        }, brightsign: {
            times: {
                timer: true, timezone: true,
            }, settings: {
                orientation: true,
                volume: true,
                brightness: false,
                reboot: true,
                reload: true,
                update: true,
                remoteControl: false,
                on: false,
                resolution: true,
                extraOrientations: true,
            }, status: {
                preview: true, connection: true,
            }, reporting: {
                cpu: true,
                disk: true,
                ram: true,
                temperature: false,
                networkType: true,
                networkName: false,
                ip: true,
                signal: false,
            }, details: {
                uuid: false,
                deviceUuid: false,
                serial: true,
                manufacturer: true,
                model: true,
                resolution: true,
                created: true,
                updated: true,
                ua: true,
                type: true,
                browser: true,
                browserVs: true,
                os: true,
                osVs: true,
                firmware: true,
                rocket: true,
                extra: false,
            },
        }, windows: {
            times: {
                timer: false, timezone: false,
            }, settings: {
                fullscreen: true,
                position: true,
                orientation: false,
                volume: false,
                brightness: false,
                reboot: false,
                reload: true,
                restart: true, // restart rocket app
                update: true,
                remoteControl: false,
                on: false,
            }, status: {
                preview: false, connection: true,
            }, reporting: {
                cpu: true,
                disk: true,
                ram: true,
                temperature: true,
                networkType: true,
                networkName: true,
                ip: true,
                signal: false,
            }, details: {
                uuid: true,
                deviceUuid: true,
                serial: true,
                manufacturer: true,
                model: true,
                resolution: true,
                created: true,
                updated: true,
                ua: true,
                type: true,
                browser: true,
                browserVs: true,
                os: true,
                osVs: true,
                firmware: true,
                rocket: true,
                extra: true,
            },
        },
    };

    const BRIGHTSIGN_RESOLUTIONS = [
        {
            name: 'FULL HD @ 30Hz', id: '1920x1080x30p',
        },
        {
            name: 'FULL HD @ 60Hz', id: '1920x1080x60p',
        },
        {
            name: '4K @ 30Hz', id: '3840x2160x30p',
        },
        {
            name: '4K @ 60Hz', id: '3840x2160x60p',
        },
        {
            name: '(XT2145, XC2055, XC4055) HDMI x2 side by side — FULL HD @ 30Hz', id: '2-1920x1080x30p',
        },
        {
            name: '(XT2145, XC2055, XC4055) HDMI x2 side by side — FULL HD @ 60Hz', id: '2-1920x1080x60p',
        },
        {
            name: '(XT2145, XC2055, XC4055) HDMI x2 side by side — 4K @ 30Hz', id: '2-3840x2160x30p',
        },
        {
            name: '(XT2145, XC2055, XC4055) HDMI x2 side by side — 4K @ 60Hz', id: '2-3840x2160x60p',
        },
        {
            name: '(XC4055  only) HDMI x3 side by side — FULL HD @ 30Hz', id: '3-1920x1080x30p',
        },
        {
            name: '(XC4055  only) HDMI x3 side by side — FULL HD @ 60Hz', id: '3-1920x1080x60p',
        },
        {
            name: '(XC4055 only) HDMI x3 side by side — 4K @ 30Hz', id: '3-3840x2160x30p',
        },
        {
            name: '(XC4055 only) HDMI x3 side by side — 4K @ 60Hz', id: '3-3840x2160x60p',
        },
        {
            name: '(XC4055 only) HDMI x4 side by side — FULL HD @ 30Hz', id: '4-1920x1080x30p',
        },
        {
            name: '(XC4055 only) HDMI x4 side by side — FULL HD @ 60Hz', id: '4-1920x1080x60p',
        },
        {
            name: '(XC4055 only) HDMI x4 side by side — 4K @ 30Hz', id: '4-3840x2160x30p',
        },
        {
            name: '(XC4055 only) HDMI x4 side by side — 4K @ 60Hz', id: '4-3840x2160x60p',
        },
    ];

    function DisplayViewCtrl($element, WS, $http, $q, $state, $scope, $stateParams, Vendor, Display, Includes, Group, App, Playlist, Store, $mdDialog, envService, $timeout, AppStylesInPlaylist, TimeZone, $window, utils) {
        this.setInitialState = () => {
            // DEFAULT
            this.loading = true;
            this.online = true;
            this.selectedIndex = 0;
            this.mode = 'view';
            this.disablePreview = true;
            this.timeZones = [];
            this.BRIGHTSIGN_RESOLUTIONS = BRIGHTSIGN_RESOLUTIONS;
            this.appsBaseUrl = envService.read('APPS_URI');

            const times = Array(24)
                .fill()
                .map((_, i) => [`${i}:00`, `${i}:15`, `${i}:30`, `${i}:45`]);
            this.times = _.flattenDeep(times);
            this.times.unshift('Not Set');
            this.labels = {
                mon: 'Monday',
                tue: 'Tuesday',
                wed: 'Wednesday',
                thu: 'Thursday',
                fri: 'Friday',
                sat: 'Saturday',
                sun: 'Sunday',
            };

            this.volumeSchedule = [{
                type: 'repeatSectionTable', key: 'schedule', templateOptions: {
                    hideCollapse: true,
                    hideArrows: true,
                    addButtonText: 'Add new time',
                    removeButtonText: 'Remove this time',
                },
            }];

            this.brightnessSchedule = [{
                type: 'repeatSectionTable', key: 'schedule', templateOptions: {
                    hideCollapse: true,
                    hideArrows: true,
                    addButtonText: 'Add new time',
                    removeButtonText: 'Remove this time',
                },
            }];

            this.defaultTimerTimes = {
                mon: {
                    on: null, off: null,
                }, tue: {
                    on: null, off: null,
                }, wed: {
                    on: null, off: null,
                }, thu: {
                    on: null, off: null,
                }, fri: {
                    on: null, off: null,
                }, sat: {
                    on: null, off: null,
                }, sun: {
                    on: null, off: null,
                },
            };
            this.checkIfOn = true;
            this.checkIfOff = true;
            // WS SUBSCRIPTIONS
            this.records = [];
            this.orientationFlag = '';

            // WIP env based features, eg. screenshots etc..
            this.featuresFlag = envService.read('features');

            this.getDisplay()
                .then(utils.handlePermissions)
                .then((display) => {
                    this.loading = false;
                    //DISPLAY
                    if (display.groupId && display.groups && display.groups.id) {
                        this.selectedIndex = 1;
                    }
                    if (display.playlistId && display.playlists && display.playlists.id) {
                        this.selectedIndex = 2;
                    }
                    this.display = Store.setSingleModelData('displays', display.id, display);

                    this.addSubscription(this.display);

                    if (!_.isBoolean(this.display.on)) {
                        this.display.on = true;
                    }

                    if (!this.display.volumeControl) {
                        this.display.volumeControl = 'constant';
                    }

                    if (!this.display.volume) {
                        this.display.volume = 0;
                    }

                    if (!this.display.brightnessControl) {
                        this.display.brightnessControl = 'constant';
                    }

                    if (!this.display.brightness) {
                        this.display.brightness = 0;
                    }

                    if (this.display.appId) {
                        this.app = _.get(this, 'display.apps', null);
                    }

                    if (this.display.groupId) {
                        this.mode = 'view';
                        this.app = _.get(this, 'display.groups.apps', null);
                    }

                    // set features to show
                    const type = _.chain(this).get('display.type', 'browser').toLower().value();
                    this.featuresDeviceSpecific = featuresDeviceSpecific[type];

                    // what to hide and what to show on this screen (tv vs browser)
                    this.features = features[type];

                    this.orientationFlag = this.display.orientation;

                    //check if timer property exists if not set default state
                    if (!this.display.timer) {
                        this.display.timer = this.defaultTimerTimes;
                    }

                    // TIME ZONES
                    this.timeZones = TimeZone.getList(this.display.os);
                    this.selectedTimeZone = _.find(this.timeZones, { value: this.display.timeZone });
                })
                .then(this.getApps)
                .then((apps) => {
                    //APPS
                    this.apps = Store.setMultiModelData('apps', apps);
                    if (this.display.appId) {
                        this.selectedApp();
                    }
                })

                .then(this.getPlaylists)
                .then((playlists) => {
                    //PLAYLISTS
                    this.playlists = Store.setMultiModelData('playlists', playlists);
                    if (this.display.playlistId) {
                        this.selectedPlaylist();
                    }
                })

                .then(this.getGroups)
                .then((groups) => {
                    //GROUPS
                    this.groups = Store.setMultiModelData('groups', groups);
                    if (this.display.groupId) {
                        this.selectedGroup();
                    }
                })
                .then(this.getVendors)
                .then((vendors) => {
                    Store.setMultiModelData('vendors', vendors);
                    this.vendors = _.keyBy(vendors, 'type');
                })
                .catch((error) => {
                    console.log('Error loading data', error);
                });
        };

        this.getZones = (query) => {
            if (!query) return $q.resolve(this.timeZones);
            const regexp = new RegExp(`${query}`, 'i');
            return $q.resolve(this.timeZones.filter((zone) => regexp.test(zone.label)));
        };

        this.selectTimeZone = (zone) => {
            this.display.timeZone = zone ? zone.value : null;
        };

        this.$onInit = () => {
            this.currentUser = Store.getCurrentUser();
            this.setInitialState();
        };

        this.discard = () => {
            this.form.$setPristine();
            this.setInitialState();
        };

        this.getDisplay = () => {
            return Display.findById({ id: $stateParams.id, filter: Includes.displays }).$promise;
        };

        this.getGroups = () => {
            const subAccountId = _.get(this, 'display.subAccountId');
            return Group.find({ filter: { include: Includes.groups.include, where: { subAccountId } } }).$promise;
        };

        this.getApps = () => {
            const subAccountId = _.get(this, 'display.subAccountId');
            return App.find({ filter: { include: Includes.apps.include, where: { subAccountId } } }).$promise;
        };

        this.getPlaylists = () => {
            const subAccountId = _.get(this, 'display.subAccountId');
            return Playlist.find({ filter: { where: { subAccountId } } }).$promise;
        };

        this.addSubscription = ({ id }) => {
            const recordName = `display:${id}`;
            WS.record.setDataWithMetadata(recordName, {
                'screenshot.large.enabled': false,
                'screenshot.small.enabled': true
            });

            WS.record.getRecord(recordName).whenReady((record) => {
                record.subscribe(({
                                      cpu,
                                      ram,
                                      disk,
                                      online,
                                      on,
                                      volume,
                                      brightness,
                                      temperature,
                                      network,
                                      networkInfo,
                                      resolution,
                                      lastSeen,
                                      screenshot,
                                      rocket,
                                  }) => {
                    if (cpu) this.display.cpu = cpu;
                    if (ram) this.display.ram = ram;
                    if (disk) this.display.disk = disk;
                    if (screenshot) this.display.screenshot = screenshot;
                    if (_.isBoolean(online)) this.display.online = online;
                    if (_.isBoolean(on)) this.display.on = on;
                    if (temperature) this.display.temperature = temperature;
                    if (network) this.display.network = network;
                    if (networkInfo) this.display.networkInfo = networkInfo;
                    if (resolution) this.display.resolution = resolution;
                    if (lastSeen) this.display.lastSeen = lastSeen;
                    if (rocket) this.display.rocket = rocket;

                    // this must be separated into CONTROL & REPORT
                    // if (volume) this.display.volume = volume;
                    // if (brightness) this.display.brightness = brightness;
                    if (cpu || ram || disk || _.isBoolean(online) || _.isBoolean(on) || volume || brightness || temperature || network || networkInfo || resolution || screenshot || lastSeen || rocket) {
                        if (!$scope.$$phase) {
                            $timeout(() => {
                                $scope.$apply();
                            });
                        }
                    }
                }, true);
                this.records.push(record);
            });
        };

        this.$onDestroy = () => {
            _.each(this.records, (record) => {
                record.unsubscribe('status');
                record.discard();
            });
        };

        this.reboot = () => {
            const eventName = `display:${this.display.id}:reboot`;
            WS.event.emit(eventName);
        };

        this.setupDebugging = () => {
            const eventName = `display:${this.display.id}:debug`;
            WS.event.emit(eventName);
        };

        $window.setupDebugging = this.setupDebugging;

        this.updateRocketPlayerApp = () => {
            const eventName = `display:${this.display.id}:updateApp`;
            WS.event.emit(eventName);
        };

        this.reloadApp = () => {
            const eventName = `display:${this.display.id}:reloadApp`;
            WS.event.emit(eventName);
        };

        this.goToLivePreview = () => {
            const recordName = `display:${this.display.id}`;
            WS.record.setDataWithMetadata(recordName, {
                'screenshot.large.image': {},
                'screenshot.large.enabled': true
            }, () => {
                $mdDialog.show({
                    locals: {
                        displayId: this.display.id,
                        orientationFlag: this.orientationFlag,
                        manufacturer: this.display.manufacturer,
                    },
                    controller: ($scope, $mdDialog, manufacturer) => {
                        WS.record.getRecord(recordName).whenReady((record) => {
                            record.subscribe('screenshot.large.image', (largeImage) => {
                                if (!largeImage) return;

                                const { height, width, data } = largeImage;
                                if (height) $scope.height = height;
                                if (width) $scope.width = width;
                                if (data) $scope.data = data;
                                if (!$scope.$$phase) {
                                    $timeout(() => {
                                        $scope.$apply();
                                    });
                                }
                            }, false);
                        });
                        $scope.manufacturer = manufacturer;

                        $scope.cancel = () => {
                            WS.record.setDataWithMetadata(recordName, 'screenshot.large.enabled', false);
                            $mdDialog.hide();
                        };
                        $scope.confirm = () => {
                            WS.record.setDataWithMetadata(recordName, 'screenshot.large.enabled', false);
                            $scope.cancel();
                        };
                    },
                    controllerAs: '$ctrl',
                    bindToController: true,
                    templateUrl: '/js/displays/live-preview-dialog/live-preview-dialog.html',
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                });
            });
        };

        this.reloadAppConfirmDialog = () => {
            $mdDialog.show({
                locals: {
                    title: 'Are you sure you want to reload current application?',
                    confirmationText: 'Please note that reload might take a second or two.',
                    confirmText: 'Yes, Reload',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        this.reloadApp();
                        $scope.cancel();
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.rebootConfirmDialog = () => {
            $mdDialog.show({
                locals: {
                    title: 'Are you sure you want to reboot device now?',
                    confirmationText: 'Please note that reboot might take minute or two.',
                    confirmText: 'Yes, reboot',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        this.reboot();
                        $scope.cancel();
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.restartConfirmDialog = () => {
            $mdDialog.show({
                locals: {
                    title: 'Are you sure you want to restart Rocket Player now?',
                    confirmationText: 'Please note that restart might take 5-10s.',
                    confirmText: 'Yes, restart',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        this.reboot();
                        $scope.cancel();
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.updateRocketPlayerAppConfirmDialog = () => {
            $mdDialog.show({
                locals: {
                    title: 'Are you sure you want to update Rocket Player App now?',
                    confirmationText: 'Please note that device will have to reboot which might take minute or two.',
                    confirmText: 'Yes, update',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        this.updateRocketPlayerApp();
                        $scope.cancel();
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.delete = () => {
            $mdDialog.show({
                locals: {
                    title: 'Are you sure you want to permanently remove this device?', confirmText: 'Yes, remove',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        this.deleteById().then($scope.cancel);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.deleteById = () => {
            return Display.removeById({ id: this.display.id })
                .$promise.then(() => {
                    return Store.removeSingleModelData('displays', this.display.id);
                })
                .then(() => {
                    $state.go('root.displays');
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.reset = () => {
            this.display.name = '';
            this.display.subName = '';
            this.display.appId = null;
            this.display.groupId = null;
            this.display.playlistId = null;
        };

        this.saveChangesModal = (itemId, type) => {
            $mdDialog.show({
                locals: {
                    title: 'Your changes have not been saved.',
                    confirmationText: 'Are you sure you want to leave this page?',
                    confirmText: 'Yes, I am sure',
                    cancelText: 'Cancel',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $mdDialog.hide();
                        if (type === 'playlist') {
                            $state.go('root.playlists.edit', { id: itemId });
                        }
                        if (type === 'app') {
                            $state.go('root.my-apps.edit-app', { appId: itemId });
                        }
                        if (type === 'group') {
                            $state.go('root.groups.view', { id: itemId });
                        }
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.goToItemTemplateModal = (event, itemId, type) => {
            event.preventDefault();
            if (this.form.$dirty) {
                this.saveChangesModal(itemId, type);
            } else {
                if (type === 'playlist') {
                    $state.go('root.playlists.edit', { id: itemId });
                }
                if (type === 'app') {
                    $state.go('root.my-apps.edit-app', { appId: itemId });
                }
                if (type === 'group') {
                    $state.go('root.groups.view', { id: itemId });
                }
            }
        };

        this.selectPreviewApp = (app, appTemplate, arrayType) => {
            this.disablePreview = false;
            this.app = app;
            this.appTemplate = appTemplate;

            if (arrayType === 'group') {
                if (this.display.groups && this.display.groups.playlists && this.display.groups.playlists.apps) this.display.groups.playlists.apps.forEach((selectedApp) => {
                    if (selectedApp.id === app.id) {
                        selectedApp.active = true;
                    } else {
                        selectedApp.active = false;
                    }
                });
            }
            if (arrayType === 'playlist') {
                this.display.playlists.apps.forEach((selectedApp) => {
                    if (selectedApp.id === app.id) {
                        selectedApp.active = true;
                    } else {
                        selectedApp.active = false;
                    }
                });
            }

            if (!$scope.$$phase) {
                $timeout(() => {
                    $scope.$apply();
                });
            }
        };

        this.selectedApp = () => {
            this.display.groupId = null;
            this.display.playlistId = null;
            this.display.apps = _.find(this.apps, { id: Number(this.display.appId) });

            if (this.display.apps) {
                this.selectPreviewApp(this.display.apps, this.display.apps.appTemplate, 'app');
            } else {
                this.disablePreview = true;
            }
        };

        this.selectedGroup = () => {
            this.display.appId = null;
            this.display.playlistId = null;
            this.display.groups = _.find(this.groups, { id: Number(this.display.groupId) });
            if (this.display.groups && this.display.groups.playlists && this.display.groups.playlists.apps && this.display.groups.playlists.apps.length) {
                this.display.groups.playlists.apps = AppStylesInPlaylist.getAppStylesInPlaylist(this.display.groups.playlists.apps, this.apps);
                // set preview app
                const appId = _.get(this, 'display.groups.playlists.apps[0].id');
                if (appId) {
                    const app = Store.getSingleModelData('apps', appId);
                    this.selectPreviewApp(app, app.appTemplate, 'group');
                }
            } else if (this.display.groups && this.display.groups.apps) {
                // set preview app
                const appId = _.get(this, 'display.groups.apps.id');
                if (appId) {
                    const app = Store.getSingleModelData('apps', appId);
                    this.selectPreviewApp(app, app.appTemplate, 'group');
                }
            } else {
                this.disablePreview = true;
            }
        };

        this.selectedPlaylist = () => {
            this.display.appId = null;
            this.display.groupId = null;
            this.display.playlists = _.find(this.playlists, { id: Number(this.display.playlistId) });
            if (this.display.playlists && this.display.playlists.apps.length) {
                this.display.playlists.apps = AppStylesInPlaylist.getAppStylesInPlaylist(this.display.playlists.apps, this.apps);

                // set preview app
                const appId = _.get(this, 'display.playlists.apps[0].id');
                if (appId) {
                    const app = Store.getSingleModelData('apps', appId);
                    this.display.playlists.apps.forEach((selectedApp) => {
                        if (selectedApp.id === appId) {
                            selectedApp.active = true;
                        }
                    });
                    this.selectPreviewApp(app, app.appTemplate, 'playlist');
                }
            } else {
                this.disablePreview = true;
            }
        };

        this.onPlaylistAppClicked = (appId, arrayType) => {
            this.disablePreview = false;
            const app = Store.getSingleModelData('apps', appId);
            this.selectPreviewApp(app, app.appTemplate, arrayType);
        };

        this.timerValidation = () => {
            const valuesArrayOn = [];
            const valuesArrayOff = [];

            const resultOn = _.map(this.display.timer, (value) => {
                valuesArrayOn.push(value.on);

                return resultOn;
            });

            const checkIfAnyOn = valuesArrayOn.some((item) => {
                return item !== null;
            });

            const resultOff = _.map(this.display.timer, (value) => {
                valuesArrayOff.push(value.off);

                return resultOff;
            });

            const checkIfAnyOff = valuesArrayOff.some((item) => {
                return item !== null;
            });
            this.checkIfOn = checkIfAnyOn;
            this.checkIfOff = checkIfAnyOff;
            if (!this.checkIfOff && !this.checkIfOn) {
                this.checkIfOn = true;
            }
        };
        this.clearTimer = () => {
            this.defaultTimerTimes = {
                mon: {
                    on: null, off: null,
                }, tue: {
                    on: null, off: null,
                }, wed: {
                    on: null, off: null,
                }, thu: {
                    on: null, off: null,
                }, fri: {
                    on: null, off: null,
                }, sat: {
                    on: null, off: null,
                }, sun: {
                    on: null, off: null,
                },
            };
            this.display.timer = this.defaultTimerTimes;
            this.checkIfOn = true;
            this.form.$setDirty();
        };

        this.isUpToDate = (display) => {
            const type = _.get(display, 'type');
            const vendor = type === 'chrome' ? 'browser' : type;
            if (!vendor) return true;

            const latestVersion = _.get(this, `vendors[${vendor}].version`);
            if (!latestVersion) return true;

            const currentVersion = _.get(display, 'rocket');
            const LATEST = Number(latestVersion.split('1.1.')[1]);
            const CURRENT = Number(currentVersion.split('1.1.')[1]);
            return CURRENT >= LATEST;
        };

        this.getVendors = () => {
            return Vendor.find().$promise;
        };

        this.saveDisplay = () => {
            Display.prototype$patchAttributes({ id: this.display.id }, {
                name: this.display.name,
                subName: this.display.subName,
                appId: this.display.appId,
                groupId: this.display.groupId,
                playlistId: this.display.playlistId,
                on: this.display.on,
                orientation: this.display.orientation,
                desiredResolution: this.display.desiredResolution,
                bounds: this.display.bounds,
                position: this.display.position,
                fullscreen: this.display.fullscreen,
                remote: this.display.remote,
                volume: this.display.volume,
                volumeControl: this.display.volumeControl,
                volumeSchedule: this.display.volumeSchedule,
                brightness: this.display.brightness,
                brightnessControl: this.display.brightnessControl,
                brightnessSchedule: this.display.brightnessSchedule,
                timeZone: this.display.timeZone,
                timer: this.display.timer,
                rocket: this.display.rocket,
            })
                .$promise.then(() => {
                return Display.findById({
                    id: this.display.id, filter: Includes.displays,
                }).$promise;
            })
                .then((display) => {
                    WS.record.snapshot(`display:${display.id}`, (error, data) => {
                        const { cpu, ram, disk, online, screenshot, temperature, lastSeen, rocket } = data;
                        Store.setSingleModelData('displays', display.id, _.extend({}, display, {
                            cpu, ram, disk, online, screenshot, temperature, lastSeen, rocket,
                        }));
                    });

                    //reload app on orientation change
                    if (this.orientationFlag !== this.display.orientation) {
                        this.reloadApp();
                    }
                    //set flag to know whether the orientation has been changed form previous e.g. for showing live preview correctly
                    this.orientationFlag = this.display.orientation;

                    this.form.$setPristine();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        let timeout = null;
        $scope.$watch('$ctrl.display.online', (online) => {
            if (online !== undefined) {
                $timeout.cancel(timeout);
                timeout = $timeout(() => {
                    this.online = online;
                }, 500);
            }
        });
    }

    module
        .config(($stateProvider) => {
            $stateProvider.state('root.displays.view', {
                url: '/:id', data: {
                    pageTitle: 'PLAYERS_VIEW.PAGE_TITLE',
                }, views: {
                    'content@root': {
                        template: '<display-view-component />',
                    },
                },
            });
        })
        .component('displayViewComponent', {
            templateUrl: '/js/displays/view-display/view-display.html', controller: DisplayViewCtrl,
        });
})(angular.module('rocket.components'));
